import http from "@/shared/http/http";
import { createPanelsApi } from "./createPanelsApi.mjs";

export const panelsApi = createPanelsApi(http);
